import * as React from "react";
import type { SVGProps } from "react";
const SvgMobileApp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="M52.005 5.185v53.63c0 1.75-1.43 3.19-3.19 3.19h-33.63c-.88 0-1.67-.36-2.25-.94-.58-.58-.94-1.37-.94-2.25V5.185c0-1.75 1.43-3.19 3.19-3.19h33.63c1.75 0 3.19 1.43 3.19 3.19Z"
    />
    <path
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="M27.625 9.215h-8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1ZM44.375 9.215h-8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1ZM27.625 24.285h-8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Z"
    />
    <path
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="M44.375 24.285h-8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Z"
    />
    <path
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="M27.625 39.355h-8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1ZM44.375 39.355h-8a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1Z"
    />
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.75}
      d="M25.065 55.965h13.96"
    />
  </svg>
);
export default SvgMobileApp;
